import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import FloatingToolsWidget from "./FloatingToolsWidget";
import ChatbotWidget from "./ChatbotWidget";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A101D] text-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloat />
      <ChatbotWidget />
      <FloatingToolsWidget />
    </div>
  );
}
